import {del, get, post, put} from "@/services/api"

const QuestionTypes = {
    SingleAnswer: {
        locKey: 'gamification.one_right_answer',
        value: 1
    },
    MultipleAnswers: {
        locKey: 'gamification.multiple_right_answers',
        value: 2
    },
    TrueFalse: {
        locKey: 'gamification.true_false',
        value: 3
    },
}
const getDefaultQuestion = () => ({
    text: '',
    points: 1,
    type: QuestionTypes.SingleAnswer.value,
    approved: true,
    subjectId: null,
    hidden: false,
    answers: []
});

const state = {
    questions: [],
    didLoadedQuestions: false,
    question: JSON.parse(JSON.stringify(getDefaultQuestion())),
    loading: false,
    questionsBySubjectId: [],
    fetchedQuestionsBySubjectId: []
};

const getters = {
    getQuestions: state => state.questions,
    getQuestionsBySubjectId: state => subjectId => state.questions.filter(q => q.subjectId === subjectId),
    getQuestionById: state => id => state.questions.find(q => q.id === id),
    getQuestionsByTestId: state => testId => state.questions.filter( q => q.testIds ? q.testIds.find(questionTestId => questionTestId === testId) : q),
    getQuestion: state => state.question,
    getQuestionTypes: () => QuestionTypes,
    didLoadedQuestions: state => state.didLoadedQuestions,
    loading: state => state.loading,
    fetchedQuestionsBySubjectId: state => state.fetchedQuestionsBySubjectId
};

const actions = {

    async fetchAllQuestions({commit}) {
        commit('setDidLoadedQuestions', false);
        const response = await get('gamification/test_questions/')
        commit('setQuestions', response.data.items)
        commit('setDidLoadedQuestions', true);
    },

    async fetchQuestionById({commit}, id) {
        commit('errors/clear', null, { root: true });
        const response = await get('gamification/test_questions/' + id);
        commit('updateQuestion', response.data.content);
        return response.data.content;
    },

    clearQuestion({commit}){
        commit('clearQuestion')
    },

    async fetchQuestionsBySubjectId({commit}, subjectId){
        commit('setDidLoadedQuestions', false);
        const response = await get(`gamification/test_questions/by_subject/${subjectId}`)
        commit('setFetchedQuestionsBySubjectId', response.data.items)
        commit('setDidLoadedQuestions', true);
    },

    async createQuestion({commit}, {item}) {
        const response = await post('gamification/test_questions/', item);
        const newQuestion = response.data.content;
        commit('addQuestion', newQuestion);
        return newQuestion.id;
    },

    async deleteQuestionById({commit}, id) {
        await del(`gamification/test_questions/${id}`)
            .then(() => {
                commit('filterQuestions', id);
            });
    },

    async updateQuestion({commit}, {item}) {
        try {
            const response = await put(`gamification/test_questions/${item.id}`, item)
            commit('updateQuestion', response.data.content)
        } catch (e) {
            alert(e.message)
        }
    },

    prepareNewQuestion({ commit }) {
        commit('prepareNew');
    },

    updateQuestionInStore({commit}, item) {
        commit('updateQuestion', item)
    },
    setLoading({commit}, loading){
        commit('setLoading', loading)
    }
}

const mutations = {
    setDidLoadedQuestions: (state, value) => (state.didLoadedQuestions = value),
    addQuestion: (state, item) => (state.questions.push(item)),
    setQuestions: (state, questions) => (state.questions = questions),
    filterQuestions: (state, id) => (state.questions = state.questions.filter(questions => questions.id !== id)),
    setAnswersToQuestion: (state, answers) => (state.question.answers = answers),
    updateQuestion: (state, item) => {
        Object.assign(state.question, item)
        const existing = state.questions.findIndex(q => q.id === item.id);
        if (existing > -1) {
            state.questions.splice(existing, 1, item);
        } else {
            state.questions.push(item);
        }
    },
    clearQuestion: (state) => (Object.assign(state.question, getDefaultQuestion())),
    prepareNew: ( state ) => {
        state.newQuestion = JSON.parse(JSON.stringify(getDefaultQuestion()));
    },
    setLoading: (state, loading) => state.loading = loading,
    setFetchedQuestionsBySubjectId: (state, items) => (state.fetchedQuestionsBySubjectId = items)

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}